exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hidden[data-v-4efd6c44] {\n  display: none;\n}\n.main-form[data-v-4efd6c44] {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  row-gap: 22px;\n}\n.main-form .action-buttons[data-v-4efd6c44] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n  gap: 12px;\n}", ""]);

// exports
